import { render, staticRenderFns } from "./CustomerMessageManage.vue?vue&type=template&id=09a525c3&scoped=true"
import script from "./CustomerMessageManage.vue?vue&type=script&lang=js"
export * from "./CustomerMessageManage.vue?vue&type=script&lang=js"
import style0 from "./CustomerMessageManage.vue?vue&type=style&index=0&id=09a525c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a525c3",
  null
  
)

export default component.exports